import './style.css';
import { getnome } from 'functions/gettabconfig';
import { useNavigate } from 'react-router-dom';

function HomeParceiro() {
    const navigate = useNavigate();
    const nome = getnome();

    return (
        <div className='container-fluid py-4'>
            <div className='welcome-card-container mb-4'>
                <div className='welcome-card'>
                    <div className='welcome-content'>
                        <h1 className='welcome-title'>Bem-vindo, {nome}!</h1>
                        <p className='welcome-subtitle'>Painel do Parceiro Actus. Gerencie suas vendas e campanhas.</p>
                    </div>
                </div>
            </div>

            <div className='row g-4'>
                <div className='col-md-4'>
                    <div className='card modern-admin-card h-100 clickable-card' onClick={() => navigate('/parceiro/vendas')}>
                        <div className='card-body d-flex flex-column align-items-center text-center p-4'>
                            <div className='icon-circle mb-3 bg-primary text-white'>
                                <i className="fas fa-shopping-cart fa-2x"></i>
                            </div>
                            <h4 className='card-title'>Vendas</h4>
                            <p className='text-muted'>Registre novas vendas e visualize seu histórico.</p>
                            <button className='btn btn-primary mt-auto rounded-pill px-4'>Acessar</button>
                        </div>
                    </div>
                </div>

                <div className='col-md-4'>
                    <div className='card modern-admin-card h-100 clickable-card' onClick={() => navigate('/parceiro/cupom')}>
                        <div className='card-body d-flex flex-column align-items-center text-center p-4'>
                            <div className='icon-circle mb-3 bg-success text-white'>
                                <i className="fas fa-ticket-alt fa-2x"></i>
                            </div>
                            <h4 className='card-title'>Cupons</h4>
                            <p className='text-muted'>Gerencie os cupons emitidos e validados.</p>
                            <button className='btn btn-success mt-auto rounded-pill px-4'>Acessar</button>
                        </div>
                    </div>
                </div>

                <div className='col-md-4'>
                    <div className='card modern-admin-card h-100 clickable-card' onClick={() => navigate('/parceiro/desconto')}>
                        <div className='card-body d-flex flex-column align-items-center text-center p-4'>
                            <div className='icon-circle mb-3 bg-warning text-white'>
                                <i className="fas fa-percentage fa-2x"></i>
                            </div>
                            <h4 className='card-title'>Descontos</h4>
                            <p className='text-muted'>Configure ofertas e promoções para seus clientes.</p>
                            <button className='btn btn-warning mt-auto rounded-pill px-4'>Acessar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeParceiro;